// @helpers
const { APIPost } = require('utilities/APIRequestHelper');
// @constants
const actionTypes = require('constants/actionTypes');
// @vendors
const moment = require('moment');
// @constants
const {
    PAYLATER_SXVALUE,
    PAYLATER_NUMSOR
} = require('constants/index');

const creditCardPayLaterRequest = () => ({
    type: actionTypes.CREDIT_CARD_PAY_LATER_REQUEST
});

const creditCardPayLaterInfoSuccess = (payload) => ({
    type: actionTypes.CREDIT_CARD_PAY_LATER_INFO_SUCCESS,
    payload
});

const creditCardPayLaterInfoError = (error) => ({
    type: actionTypes.CREDIT_CARD_PAY_LATER_INFO_ERROR,
    error
});

const creditCardPayLaterInfoReset = () => ({
    type: actionTypes.CREDIT_CARD_PAY_LATER_RESET
});

const getCreditCardPayLaterOptedInfo = (immCard) => dispatch => {

    dispatch(creditCardPayLaterRequest());
    const params = {
        query: {
            cardNumber : immCard.get('number'),
            contractNumber : immCard.getIn(['contract','number']),
            from : moment().startOf('day').subtract(5, 'year').format('YYYY-MM-DD'),
            numsor : PAYLATER_NUMSOR,
            product : immCard.getIn(['product','type']),
            sxvalue : PAYLATER_SXVALUE,
            to : moment().startOf('day').format('YYYY-MM-DD')
        }
    };

    return APIPost({
        dispatch,
        params,
        endpoint: 'creditCardPayLaterOptedInfo'
    })
    .then((response) => {
        dispatch(creditCardPayLaterInfoSuccess(response));
    })
    .catch( response => {
        if (!!response.error) {
            dispatch(creditCardPayLaterInfoError(response.error));
        } else {
            throw response;
        }
    })
}

module.exports = {
    getCreditCardPayLaterOptedInfo,
    creditCardPayLaterInfoReset
};

